<div class="bg-secondary">
    <main>
        <div class="container">
            <p>&nbsp;</p>
            <!--Grid row-->
            <div class="row1">
                <b-card>
                    <b-form-group label="UserName/Email" label-for="input-1">
                        <b-form-input id="input-1" v-model="username" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="fullName" label-for="fullName">
                      <b-form-input id="fullName" v-model="depositType.fullName" disabled></b-form-input>
                  </b-form-group>
                    <b-form-group label="Deposit Type" label-for="input-4">
                      <b-form-select v-model="depositType.depositType" :options="depositOptions"></b-form-select>
                  </b-form-group>

                  <b-form-group label="Currency" label-for="input-4">
                    <b-form-select v-model="depositType.currency" :options="currencyOptions"></b-form-select>
                </b-form-group>
                <b-form-group label="Reflecting In Bank" label-for="reflecting">
                  <b-form-select v-model="depositType.reflectingInBank" :options="reflectingInBankOptions"></b-form-select>
              </b-form-group>

                    <b-form-group label="Reference" label-for="input-2">
                        <b-form-input id="input-2" v-model="depositType.reference" required></b-form-input>
                    </b-form-group>

                    <b-form-group label="Comment" label-for="input-3">
                        <b-form-input id="input-3" v-model="depositType.comment"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Ewallet Sent to" label-for="input-3">
                      <b-form-input  v-model="ewalletto"></b-form-input>
                  </b-form-group>

                    <b-form-group label="Amount" label-for="input-4">
                        <b-form-input id="input-4" v-model="depositType.amount" required></b-form-input>
                    </b-form-group>

                    <b-form-group>
                        <base-button class="btn-3" @click="busy=true" type="primary">Deposit</base-button>
                    </b-form-group>
                </b-card>
            </div>
            <!--Grid row-->
            <b-overlay :show="busy" no-wrap >
                <template #overlay>
                    <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
                      <b-icon icon="cloud" font-scale="4"></b-icon>
                      <div class="mb-3">Processing...</div>
                      <div class="text-center">
                        <b-spinner type="grow" label="Spinning"></b-spinner>
                      </div>
                    </div>
                    <div
                      v-else
                      ref="dialog"
                      tabindex="-1"
                      role="dialog"
                      aria-modal="false"
                      aria-labelledby="form-confirm-label"
                      class="text-center p-3"
                    >
                      <p><strong id="form-confirm-label">Are you sure, you want to do a deposit?</strong></p>
                      <div class="d-flex">
                        <b-button variant="outline-danger" class="mr-3" @click="onCancel">
                          Cancel
                        </b-button>
                        <b-button variant="outline-success" @click="onOK">OK</b-button>
                      </div>
                    </div>
                  </template>
              </b-overlay>
              <b-overlay :show="decision" no-wrap >
                <template #overlay>
                    <div
                      ref="dialog"
                      tabindex="-1"
                      role="dialog"
                      aria-modal="false"
                      aria-labelledby="form-confirm-label"
                      class="text-center p-3"
                    >
                    <div class="alert alert-warning d-flex align-items-center" role="alert">
                      <i class="fa fa-exclamation-circle"></i>
                      <p id="form-confirm-label"> {{decisionMsg}}</p>
                    </div>
                      <div class="d-flex">
                        <b-button variant="outline-danger" class="mr-3" @click="onCancel">
                          Cancel Transaction
                        </b-button>
                        <b-button variant="outline-success" @click="onOverWriteOK">Override & do Deposit</b-button>
                      </div>
                    </div>
                  </template>
              </b-overlay>
            <p>&nbsp;</p>
        </div>
    </main>
    <!--Main layout-->
</div>